// 카카오 채널톡 설정 섹션 URL (2026-10-20 KST 추가)
const kakaoChannelSettingsSection = "/kakao-channel-settings";

export const kakaoChannelSettingsPath = kakaoChannelSettingsSection;
